<div class="section">
    <router-outlet></router-outlet>
</div>